import React, { Fragment } from 'react'

import DayPicker from 'react-day-picker'
import { formatDate, parseDate } from 'react-day-picker/moment'

import 'moment/locale/es'
import { ErrorContainer } from 'components/common'
import Message from 'components/message'

import { DayPickerResponsive } from '../styled'
const DatePickerResponsive = ({
  onChange,
  value,
  fromError,
  locale,
  dayPickerProps,
  numberOfMonths,
  disabledDays,
  captionElement,
  fromMonth,
  toMonth,
  initialMonth,
  month,
  ...rest
}) => (
  <DayPickerResponsive>
    <DayPicker
      value={value}
      selectedDays={value}
      formatDate={formatDate}
      parseDate={parseDate}
      onDayClick={onChange}
      onChange={onChange}
      disabledDays={disabledDays}
      numberOfMonths={numberOfMonths || 12} //number of months to show at one time
      locale={locale}
      {...dayPickerProps}
      navbarElement={<Fragment />}
      captionElement={captionElement}
      fromMonth={fromMonth}
      toMonth={toMonth}
      initialMonth={initialMonth}
      month={month}
      {...rest}
    />
    {fromError && (
      <ErrorContainer>
        <Message type="formInputError">{fromError}</Message>
      </ErrorContainer>
    )}
  </DayPickerResponsive>
)

export default DatePickerResponsive
